import { DetailedHTMLProps, InputHTMLAttributes, ReactNode } from 'react';

import { WithRef } from 'support/types/withRef';
import { Checkbox } from 'components/Form/Checkbox/Checkbox';
import { FieldsetLegend } from 'components/Form/Input/FieldsetLegend/FieldsetLegend';

const CheckboxGroupGroup = ({
  children,
  label,
  legendVariant,
  required,
  className,
  description,
}: {
  children: ReactNode;
  label?: string;
  legendVariant?: 'default' | 'large';
  required?: boolean;
  className?: string;
  description?: ReactNode;
}) => {
  return (
    <fieldset className={className}>
      <FieldsetLegend
        label={label}
        description={description}
        variant={legendVariant}
        required={required}
        className="mb-2"
      />
      <div className="space-y-3">{children}</div>
    </fieldset>
  );
};

type CheckboxGroupItemProps = {
  label: ReactNode;
  description?: ReactNode;
  hasErrors?: boolean;
} & Omit<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  'type' | 'id' | 'className' | 'ref'
>;

const CheckboxGroupItem = ({
  label,
  description,
  hasErrors,
  ref,
  ...inputProps
}: WithRef<CheckboxGroupItemProps, HTMLInputElement>) => {
  return <Checkbox ref={ref} label={label} description={description} error={hasErrors} {...inputProps} />;
};

export const CheckboxGroup = Object.assign({}, { Group: CheckboxGroupGroup, Item: CheckboxGroupItem });
